import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import empperfdetal from '@/page/hair/empperfdetal'
import empmanager from '@/page/hair/empmanager'
import cardtranhistory from "../page/hair/cardtranhistory";
import haircustfiles from "../page/hair/haircustfiles"
import manager from "../page/manager/managerlogin"
import cardcourse from "../page/hair/cardcourse"
import staffinfo from "../page/intebo/intebostaff/staffinfo"
import addstaffinfo from "../page/intebo/intebostaff/addstaffinfo"
import intebostore from "../page/intebo/intebostore/intebostore"
import addintebostore from "../page/intebo/intebostore/addintebostore"
import addinteboparentstore from "../page/intebo/intebostore/addinteboparentstore"
import inteboschedulinginfo from "../page/intebo/inteboscheduling/inteboschedulinginfo"
import inteboMachineApply from "../page/intebo/inteboapply/inteboMachineApply"
import inteboMachine from "../page/intebo/inteboapply/inteboMachine"
import newmanager from '../page/manager/newmanager'
import hairhl from '../page/manager/hairhl'
import hairdata from '../page/manager/hairdata'
import hairjx from '../page/manager/hairjx'
import managertabbar from '../page/manager/managertabbar'
import opencard from '../page/intebo/opencard'
import buycardcourse from '../page/intebo/buycardcourse'
import cash from '../page/intebo/cash'
import headstaff from '../page/intebo/headstaff'
import intebocardhistory from '../page/intebo/intebocardhistory'
import intebocashtabbar from '../page/intebo/intebocashtabbar'
import intebologin from '../page/intebo/intebologin'
import mydata from '../page/intebo/mydata'
import beautyheadstaff from '../page/beauty/beautyheadstaff'
import beautymemberinfo from '../page/beauty/beautymemberinfo'
import beautylogin from '../page/beauty/beautylogin'
import beautyorder from '../page/beauty/beautyorder'
import addorder from '../page/beauty/addorder'
import storebeautyhead from '../page/beauty/storebeautyhead'
import sendcard from '../page/beauty/sendcard'
import beautytabbar from '../page/beauty/beautytabbar'
import beautylog from '../page/beauty/beautylog'
import myorder from '../page/beauty/myorder'
import beautylamp from '../page/beauty/beautylamp'
import beautycardtran from '../page/beauty/beautycardtran'
import beautygrid from '../page/beauty/beautygrid'
import hairheadstaff from '../page/manager/hairheadstaff'
import hairstaff from '../page/manager/hairstaff'
import bigcard from '../page/beauty/bigcard'
import hairmemberinfo from '../page/manager/hairmemberinfo'
import hairorder from '../page/manager/hairorder'
import addhairorder from '../page/manager/addhairorder'
import myhairorder from '../page/manager/myhairorder'
import hairlog from '../page/manager/hairlog'
import hairgrid from '../page/manager/hairgrid'
import sendhaircard from '../page/manager/sendhaircard'
import hairlamp from '../page/manager/hairlamp'
import staffjx from '../page/manager/staffjx'
import staffdata from '../page/manager/staffdata'
import hairstafftabbar from '../page/manager/hairstafftabbar'
import cardddday31 from '../page/beauty/cardddday31'
import beauty31sumdata from '../page/beauty/beauty31sumdata'
import indibabuydd from '../page/beauty/indibabuydd'
import indibabuydetal from '../page/beauty/indibabuydetal'
import indibawdd from '../page/beauty/indibawdd'
import indibawdddetal from '../page/beauty/indibawdddetal'
import indibaxfinfo from '../page/beauty/indibaxfinfo'
import indibaxfinfodetal from '../page/beauty/indibaxfinfodetal'
import indibaxfcountinfo from '../page/beauty/indibaxfcountinfo'
import indibaxfcountinfodetal from '../page/beauty/indibaxfcountinfodetal'
import indibamanaer from '../page/beauty/indibamanaer'
import beautysalelog from '../page/beauty/beautysalelog'
import beautyxflog from '../page/beauty/beautyxflog'
import beautyexamine from '../page/beauty/beautyexamine'
import beautystaffexamine from '../page/beauty/beautystaffexamine'
import beautystaffexaminedetal from '../page/beauty/beautystaffexaminedetal'
import beautystaffdata from '../page/beauty/beautystaffdata'
import beautystafftabbar from '../page/beauty/beautystafftabbar'
import beautyheadstaffcopy from '../page/beauty/beautyheadstaffcopy'
import hairxflog from '../page/manager/hairxflog'
import hairsalelog from '../page/manager/hairsalelog'
import hairstorereport from '../page/manager/hairstorereport'
import hairleadermanager from '../page/manager/hairleadermanager'
import douyincjlv from '../page/beauty/douyincjlv'
import hairdouyincjlv from '../page/manager/hairdouyincjlv'
import hairwork from '../page/hair/hairwork'
import addhairwork from '../page/hair/addhairwork'
import hairbasic from '../page/hair/hairbasic'
import staffrest from '../page/hair/staffrest'
import hairworkexamine from '../page/hair/hairworkexamine'
import bighealthy from '../page/beauty/bighealthy'
import cardbeddinginfo from '../page/beauty/cardbeddinginfo'
import bighealthytotal from '../page/beauty/bighealthytotal'
import pricelist from '../page/pricelist/pricelist'
import pricelistdetal from '../page/pricelist/pricelistdetal'
import beautymanagerrank from "../page/beauty/beautymanagerrank";
import beautyloginnew from "../page/beauty/beautyloginnew";
import managerloginnew from "../page/manager/managerloginnew";
import empmanagernew from "../page/hair/empmanagernew";
import checkindata from "../page/checkindata/checkindata";
import groupbyingdata from "../page/groupbyingdata";
import payimage from "../page/pay/payimage";
import intebotab from "../page/intebo/intebotab/intebotab";
import addintebosale from "../page/intebo/intebotab/addintebosale";
import intebosale from "../page/intebo/intebotab/intebosale";
import intebotrain from "../page/intebo/intebotab/intebotrain";
import addintebotrain from "../page/intebo/intebotab/addintebotrain";
import addintebostoresale from "../page/intebo/intebotab/addintebostoresale";
import intebostoresale from "../page/intebo/intebotab/intebostoresale";
import notpay from "../page/intebo/intebotab/notpay";
import notbackdj from "../page/intebo/intebotab/notbackdj";
import notsend from "../page/intebo/intebotab/notsend";
import notintroduce from "../page/intebo/intebotab/notintroduce";
import staffposchange from "../page/intebo/intebostaff/staffposchange";
import staffleave from "../page/intebo/intebostaff/staffleave";
import staffchangehistory from "../page/intebo/intebostaff/staffchangehistory";
import inteboQyWechatLogin from "../page/intebo/inteboQyWechatLogin";
import inteboQyWechatLoginNew from "../page/intebo/inteboQyWechatLoginNew";
import inteboteam from "../page/intebo/intebostaff/inteboteam";
import intebostafffine from "../page/intebo/intebostaff/intebostafffine";
import nobackbonus from "../page/intebo/intebotab/notbackbonus";
import dailyreport from "../page/intebo/intebotab/dailyreport";
import intebostaffattend from "../page/intebo/intebostaff/intebostaffattend";
import intebosn from "../page/intebo/intebotab/intebosn";
import intebowebsite from "../page/intebo/intebowebsite/intebowebsite";
import seachwebsite from "../page/intebo/intebowebsite/seachwebsite";
import intebocheckout from "../page/intebo/intebotab/intebocheckout";
import staffbandwxopenid from "../page/staffband/staffbandwxopenid";
import cardexamine from "../page/examine/cardexamine";
import htyslogin from "../page/login/htyslogin";
import visit from "../page/check/visit";
import visitsucess from "../page/check/visitsucess";
import visitcust from "../page/check/visitcust";
import jbm from "../page/scqjmb/jmb";
import kmymmanager from "../page/kmym/index";
import headpayount from "../page/headpayout/MpayoutList";
import ddlogin from "../page/login/ddlogin";


Vue.use(Router)

export default new Router({
    routes: [
        {
            path: "/intebologin",
            name: "intebologin",
            component: intebologin,
        },
        {
            path: '/payout/:sysbillid',
            name: 'MpayoutDetail',
            component: () => import('../page/headpayout/MpayoutDetail.vue'),
            meta: { title: '支出单详情' }
        },
        {
            path: "/ddlogin",
            name: "ddlogin",
            component: ddlogin,
        },
        {
            path: "/visit",
            name: "visit",
            component: visit,
        },
        {
            path: "/headpayount",
            name: "headpayount",
            component: headpayount,
        },
        {
            path: "/kmymmanager",
            name: "kmymmanager",
            component: kmymmanager,
        },
        {
            path: "/jbm",
            name: "jbm",
            component: jbm,
        },
        {
            path: "/visitcust",
            name: "visitcust",
            component: visitcust,
        },
        {
            path: "/visitsucess",
            name: "visitsucess",
            component: visitsucess,
        },
        {
            path: "/nobackbonus",
            name: "nobackbonus",
            component: nobackbonus,
        },
        {
            path: "/htyslogin",
            name: "htyslogin",
            component: htyslogin,
        },
        {
            path: "/cardexamine",
            name: "cardexamine",
            component: cardexamine,
        },
        {
            path: "/staffbandwxopenid",
            name: "staffbandwxopenid",
            component: staffbandwxopenid,
        },
        {
            path: "/intebocheckout",
            name: "intebocheckout",
            component: intebocheckout,
        },
        {
            path: "/seachwebsite",
            name: "seachwebsite",
            component: seachwebsite,
        },
        {
            path: "/intebowebsite",
            name: "intebowebsite",
            component: intebowebsite,
        },
        {
            path: "/intebosn",
            name: "intebosn",
            component: intebosn,
        },
        {
            path: "/intebostaffattend",
            name: "intebostaffattend",
            component: intebostaffattend,
        },
        {
            path: "/dailyreport",
            name: "dailyreport",
            component: dailyreport,
        },
        {
            path: "/inteboQyWechatLogin",
            name: "inteboQyWechatLogin",
            component: inteboQyWechatLogin,
        },
        {
            path: "/inteboQyWechatLoginNew",
            name: "inteboQyWechatLoginNew",
            component: inteboQyWechatLoginNew,
        },
        {
            path: "/intebostafffine",
            name: "intebostafffine",
            component: intebostafffine,
        },
        {
            path: "/inteboteam",
            name: "inteboteam",
            component: inteboteam,
        },
        {
            path: "/staffleave",
            name: "staffleave",
            component: staffleave,
        },
        {
            path: "/staffchangehistory",
            name: "staffchangehistory",
            component: staffchangehistory,
        },
        {
            path: "/groupbyingdata",
            name: "groupbyingdata",
            component: groupbyingdata,
        },
        {
            path: "/staffposchange",
            name: "staffposchange",
            component: staffposchange,
        },
        {
            path: "/notintroduce",
            name: "notintroduce",
            component: notintroduce,
        },
        {
            path: "/notsend",
            name: "notsend",
            component: notsend,
        },
        {
            path: "/notbackdj",
            name: "notbackdj",
            component: notbackdj,
        },
        {
            path: "/notpay",
            name: "notpay",
            component: notpay,
        },
        {
            path: "/intebostoresale",
            name: "intebostoresale",
            component: intebostoresale,
        },
        {
            path: "/addintebostoresale",
            name: "addintebostoresale",
            component: addintebostoresale,
        },
        {
            path: "/addintebotrain",
            name: "addintebotrain",
            component: addintebotrain,
        },
        {
            path: "/intebosale",
            name: "intebosale",
            component: intebosale,
        },
        {
            path: "/intebotrain",
            name: "intebotrain",
            component: intebotrain,
        },
        {
            path: "/addintebosale",
            name: "addintebosale",
            component: addintebosale,
        },
        {
            path: "/intebotab",
            name: "intebotab",
            component: intebotab,
        },
        {
            path: "/hairbasic",
            name: "hairbasic",
            component: hairbasic,
        },
        {
            path: "/payimage",
            name: "payimage",
            component: payimage,
        },
        {
            path: "/checkindata",
            name: "checkindata",
            component: checkindata,
        },
        {
            path: "/empmanagernew",
            name: "empmanagernew",
            component: empmanagernew,
        },
        {
            path: "/managerloginnew",
            name: "managerloginnew",
            component: managerloginnew,
        },
        {
            path: "/beautyloginnew",
            name: "beautyloginnew",
            component: beautyloginnew,
        },
        {
            path: "/beautymanagerrank",
            name: "beautymanagerrank",
            component: beautymanagerrank,
        },
        {
            path: "/pricelistdetal",
            name: "pricelistdetal",
            component: pricelistdetal,
        },
        {
            path: "/pricelist",
            name: "pricelist",
            component: pricelist,
        },
        {
            path: "/bighealthy",
            name: "bighealthy",
            component: bighealthy,
        },
        {
            path: "/bighealthytotal",
            name: "bighealthytotal",
            component: bighealthytotal,
        },
        {
            path: "/cardbeddinginfo",
            name: "cardbeddinginfo",
            component: cardbeddinginfo,
        },
        {
            path: "/hairworkexamine",
            name: "hairworkexamine",
            component: hairworkexamine,
        },
        {
            path: "/staffrest",
            name: "staffrest",
            component: staffrest,
        },
        {
            path: "/hairstorereport",
            name: "hairstorereport",
            component: hairstorereport,
        },
        {
            path: "/addhairwork",
            name: "addhairwork",
            component: addhairwork,
        },
        {
            path: "/douyincjlv",
            name: "douyincjlv",
            component: douyincjlv,
        },
        {
            path: "/hairdouyincjlv",
            name: "hairdouyincjlv",
            component: hairdouyincjlv,
        },
        {
            path: "/hairleadermanager",
            name: "hairleadermanager",
            component: hairleadermanager,
        },
        {
            path: "/beautyexamine",
            name: "beautyexamine",
            component: beautyexamine,
        },
        {
            path: "/beautystaffexamine",
            name: "beautystaffexamine",
            component: beautystaffexamine,
        },
        {
            path: "/beautysalelog",
            name: "beautysalelog",
            component: beautysalelog,
        },
        {
            path: "/beauty31sumdata",
            name: "beauty31sumdata",
            component: beauty31sumdata,
        },
        {
            path: "/indibaxfcountinfodetal",
            name: "indibaxfcountinfodetal",
            component: indibaxfcountinfodetal,
        },
        {
            path: "/indibabuydetal",
            name: "indibabuydetal",
            component: indibabuydetal,
        },
        {
            path: "/indibaxfinfodetal",
            name: "indibaxfinfodetal",
            component: indibaxfinfodetal,
        },
        {
            path: "/indibawdddetal",
            name: "indibawdddetal",
            component: indibawdddetal,
        },
        {
            path: "/beautystafftabbar",
            name: "beautystafftabbar",
            component: beautystafftabbar,
            children: [
                {
                    path: "/",
                    component: beautyheadstaffcopy,
                    name: "beautyheadstaffcopy",
                    meta: {
                        keepAlive: true,
                    }
                },
                {
                    path: "/beautyheadstaffcopy",
                    component: beautyheadstaffcopy,
                    name: "beautyheadstaffcopy",
                    meta: {
                        keepAlive: true,
                    }
                },
                {
                    path: "/beautystaffexaminedetal",
                    component: beautystaffexaminedetal,
                    name: "beautystaffexaminedetal",
                    meta: {
                        keepAlive: true,
                    }
                },
                {
                    path: "/beautyxflog",
                    component: beautyxflog,
                    name: "beautyxflog",
                    meta: {
                        keepAlive: true,
                    }
                },
                {
                    path: "/beautystaffdata",
                    component: beautystaffdata,
                    name: "beautystaffdata",
                    meta: {
                        keepAlive: true,
                    }
                }
            ]
        },
        {
            path: '/indibamanaer',
            name: "indibamanaer",
            component: indibamanaer,
            meta: {
                title: "INDIBA管理"
            },
            children: [
                {
                    path: "/",
                    component: indibabuydd,
                    meta: {
                        keepAlive: true,
                    }
                },
                {
                    path: "/indibabuydd",
                    component: indibabuydd,
                    meta: {
                        keepAlive: true
                    }
                },
                {
                    path: "/indibawdd",
                    component: indibawdd,
                    meta: {
                        keepAlive: true
                    }
                },
                {
                    path: "/indibaxfinfo",
                    component: indibaxfinfo,
                    meta: {
                        keepAlive: true
                    }

                },
                {
                    path: "/indibaxfcountinfo",
                    component: indibaxfcountinfo,
                    meta: {
                        keepAlive: true
                    }
                }
            ]
        },
        {
            path: "/hairstafftabbar",
            name: "hairstafftabbar",
            component: hairstafftabbar,
            children: [
                {
                    path: "/",
                    name: "hairstaff",
                    component: hairstaff,
                },
                {
                    path: "/hairstaff",
                    name: "hairstaff",
                    component: hairstaff,
                },
                {
                    path: "/hairxflog",
                    name: "hairxflog",
                    component: hairxflog
                },
                {
                    path: "/hairsalelog",
                    name: "hairsalelog",
                    component: hairsalelog
                },
                {
                    path: "/staffdata",
                    name: "staffdata",
                    component: staffdata
                },
                {
                    path: "/hairwork",
                    name: "hairwork",
                    component: hairwork,
                }
            ]
        },
        {
            path: "/sendhaircard",
            name: "sendhaircard",
            component: sendhaircard,
        },
        {
            path: "/staffdata",
            name: "staffdata",
            component: staffdata,
        },
        {
            path: "/cardddday31",
            name: "cardddday31",
            component: cardddday31,
        },
        {
            path: "/staffjx",
            name: "staffjx",
            component: staffjx,
        },
        {
            path: "/hairjx",
            name: "hairjx",
            component: hairjx,
        },
        {
            path: "/newmanager",
            name: "newmanager",
            component: newmanager,
        },
        {
            path: "/hairdata",
            name: "hairdata",
            component: hairdata,
        },
        {
            path: "/hairlamp",
            name: "hairlamp",
            component: hairlamp,
        },
        {
            path: "/addhairorder",
            name: "addhairorder",
            component: addhairorder,
        },
        {
            path: "/hairgrid",
            name: "hairgrid",
            component: hairgrid,
        },
        {
            path: "/hairlog",
            name: "hairlog",
            component: hairlog,
        },
        {
            path: "/myhairorder",
            name: "myhairorder",
            component: myhairorder,
        },
        {
            path: "/bigcard",
            name: "bigcard",
            component: bigcard,
        },
        {
            path: "/hairorder",
            name: "hairorder",
            component: hairorder,
        },
        {
            path: "/hairmemberinfo",
            name: "hairmemberinfo",
            component: hairmemberinfo,
        },
        {
            path: "/hairstaff",
            name: "hairstaff",
            component: hairstaff,
        },
        {
            path: "/beautyorder",
            name: "beautyorder",
            component: beautyorder,
        },
        {
            path: "/hairheadstaff",
            name: "hairheadstaff",
            component: hairheadstaff,
        },
        {
            path: "/beautygrid",
            name: "beautygrid",
            component: beautygrid,
        },
        {
            path: "/beautycardtran",
            name: "beautycardtran",
            component: beautycardtran,
        },
        {
            path: "/beautylamp",
            name: "beautylamp",
            component: beautylamp,
        },
        {
            path: "/myorder",
            name: "myorder",
            component: myorder,
        },
        {
            path: "/beautylog",
            name: "beautylog",
            component: beautylog,
        },
        /*{
          path:"/beautytabbar",
          name:"beautytabbar",
          component:beautytabbar,
          children:[
            {
              path:"/",
              name:"storebeautyhead",
              component:storebeautyhead
            },
            {
              path:"/storebeautyhead",
              name:"storebeautyhead",
              component:storebeautyhead
            },
            {
              path:"/sendcard",
              name:"sendcard",
              component:sendcard
            }
          ]
        },*/
        {
            path: "/sendcard",
            name: "sendcard",
            component: sendcard,
        },
        {
            path: "/storebeautyhead",
            name: "storebeautyhead",
            component: storebeautyhead,
        },
        {
            path: "/addorder",
            name: "addorder",
            component: addorder,
        },
        {
            path: "/beautylogin",
            name: "beautylogin",
            component: beautylogin,
        },
        {
            path: "/beautymemberinfo",
            name: "beautymemberinfo",
            component: beautymemberinfo,
        },
        {
            path: "/beautyheadstaff",
            name: "beautyheadstaff",
            component: beautyheadstaff,
        },
        {
            path: "/intebocashtabbar",
            name: "intebocashtabbar",
            component: intebocashtabbar,
            children: [
                {
                    path: "/",
                    name: "headstaff",
                    component: headstaff
                },
                {
                    path: "/cash",
                    name: "cash",
                    component: cash
                },
                {
                    path: "/opencard",
                    name: "opencard",
                    component: opencard
                },
                {
                    path: "/buycardcourse",
                    name: "buycardcourse",
                    component: buycardcourse
                },
                {
                    path: "/headstaff",
                    name: "headstaff",
                    component: headstaff
                },
                {
                    path: "/mydata",
                    name: "mydata",
                    component: mydata
                }
            ]
        },
        {
            path: "/intebocardhistory",
            name: "intebocardhistory",
            component: intebocardhistory,
        },
        {
            path: "/headstaff",
            name: "headstaff",
            component: headstaff,
        },
        {
            path: "/buycardcourse",
            name: "buycardcourse",
            component: buycardcourse,
        },
        {
            path: "/cash",
            name: "cash",
            component: cash,
        },
        {
            path: "/opencard",
            name: "opencard",
            component: opencard,
        },
        {
            path: "/managertabbar",
            name: "managertabbar",
            component: managertabbar,
            children: [
                {
                    path: "/",
                    name: "newmanager",
                    component: newmanager
                },
                {
                    path: "/hairjx",
                    name: "hairjx",
                    component: hairjx
                },
                {
                    path: "/hairdata",
                    name: "hairdata",
                    component: hairdata
                },
                {
                    path: "/hairhl",
                    name: "hairhl",
                    component: hairhl
                },
                {
                    path: "/newmanager",
                    name: "newmanager",
                    component: newmanager
                },
            ]
        },
        {
            path: '/inteboMachine',
            name: 'inteboMachine',
            component: inteboMachine
        },
        {
            path: '/inteboMachineApply',
            name: 'inteboMachineApply',
            component: inteboMachineApply
        },
        {
            path: '/',
            name: 'HelloWorld',
            component: HelloWorld
        },
        {
            path: '/empperfdetal',
            name: 'empperfdetal',
            component: empperfdetal,
            meta: {
                title: "员工提成明细"
            }
        },
        {
            path: '/empmanager',
            name: "empmanager",
            component: empmanager,
            meta: {
                keepAlive: true,
                title: "员工端"
            }
        },
        {
            path: '/cardtranhistory',
            name: "cardtranhistory",
            component: cardtranhistory,
            meta: {
                title: "会员交易历史"
            }
        },
        {
            path: '/haircustfiles',
            name: "haircustfiles",
            component: haircustfiles,
            meta: {
                title: "会员美发档案"
            }
        },
        {
            path: '/manager',
            name: "manager",
            component: manager,
            meta: {
                title: "管理层中心",
                keepAlive: true,
            }
        },
        {
            path: "/cardcourse",
            name: "cardcourse",
            component: cardcourse,
            meta: {
                title: "会员疗程信息"
            }
        },
        {
            path: "/staffinfo",
            name: "staffinfo",
            component: staffinfo,
            meta: {
                title: "音特波员工信息"
            }
        },
        {
            path: "/addstaffinfo",
            name: "addstaffinfo",
            component: addstaffinfo,
            meta: {
                title: "员工入职"
            }
        },
        {
            path: "/intebostore",
            name: "intebostore",
            component: intebostore,
            meta: {
                title: "客户信息"
            }
        },
        {
            path: "/addintebostore",
            name: "addintebostore",
            component: addintebostore,
            meta: {
                title: "新增客户信息"
            }
        },
        {
            path: "/addinteboparentstore",
            name: "addinteboparentstore",
            component: addinteboparentstore,
            meta: {
                title: "新增品牌信息"
            }
        },
        {
            path: "/inteboschedulinginfo",
            name: "inteboschedulinginfo",
            component: inteboschedulinginfo,
            meta: {
                title: "员工排班"
            }
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js